/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component} from '@angular/core';
import template from './external-demand-source-item-page.component.html';

import {AdminResourceItemPageBase} from '../../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-external-demand-source-item-page',
  template
})
export class ExternalDemandSourceItemPageComponent extends AdminResourceItemPageBase {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
